import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { KineticHero } from "./components/KineticHero";
import { EditorialMarquee } from "./components/EditorialMarquee";
import { PortfolioGrid } from "./components/PortfolioGrid";
import { CaseStudies } from "./components/CaseStudies";
import { Services } from "./components/Services";
import { Testimonials } from "./components/Testimonials";
import { About } from "./components/About";
import { Contact } from "./components/Contact";
import { FloatingCTA } from "./components/FloatingCTA";
import { MobileBar } from "./components/MobileBar";
import { CustomCursor } from "./components/CustomCursor";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true, anchors: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="App bg-[#FAFAFA] text-[#0A0A0A]">
      <Navbar />
      <main>
        <KineticHero />
        <EditorialMarquee />
        <PortfolioGrid />
        <CaseStudies />
        <Services />
        <Testimonials />
        <About />
        <Contact />
      </main>
      <FloatingCTA />
      <MobileBar />
      <CustomCursor />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
